import { IApplicationState } from '../../types/redux';

export function selectRecommendations(state: IApplicationState) {
  return state.recommendations?.recommendations || [];
}
